import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import imgPerishable from "../../../../assets/imgs/services/nationals/perishable.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";
import NationalDescription from "../../../../components/national-description/national-description";

import perishable1Icon from "../../../../assets/imgs/services/nationals/perishable-icons/perishable1.svg"
import perishable2Icon from "../../../../assets/imgs/services/nationals/perishable-icons/perishable2.svg"
import perishable3Icon from "../../../../assets/imgs/services/nationals/perishable-icons/perishable3.svg"
import perishable4Icon from "../../../../assets/imgs/services/nationals/perishable-icons/perishable4.svg"
import perishable5Icon from "../../../../assets/imgs/services/nationals/perishable-icons/perishable5.svg"
import perishable6Icon from "../../../../assets/imgs/services/nationals/perishable-icons/perishable6.svg"

function PerishableGoods() {
  const [tPerishable] = useTranslation("perishableGoodPage");
  const [tSMetaData] = useTranslation("metaData");
  const idPerishable = "158bdddf-e801-4157-9720-40346a29601e";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [openAccordion, setOpenAccordion] = useState(null);

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[3]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[3]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idPerishable}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      )
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("perecederos.title")}</title>
        <meta
          name="description"
          content={tSMetaData("perecederos.description")}
        />
      </Helmet>
      {/* <ImageHeader
        section={tPerishable("header.section")}
        title={tPerishable("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tPerishable("description.content"))
        }
        quoteBtn={tPerishable("header.quote-btn")}
        quoteProductID="btnQuotePerishable"
        contactSales={tPerishable("header.contact-sales")}
        contactProductID="btnContactPerishable"
        imgBackground={imgPerishable}
      /> */}
      <ImageHeader
        imgBackground={imgPerishable}
      />
      {/* <Accordion
        title={tPerishable("accordion-1.title")}
        content={
          accordion1
            ? JSON.parse(accordion1)
            : JSON.parse(tPerishable("accordion-1.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tPerishable("accordion-2.title")}
        content={
          accordion2
            ? JSON.parse(accordion2)
            : JSON.parse(tPerishable("accordion-2.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tPerishable("accordion-3.title")}
        content={JSON.parse(tPerishable("accordion-3.content"))}
      /> */}
      <div className="info-national-content">
        <NationalDescription 
          title={tPerishable("header.title")} 
          description={
            textDescription
            ? JSON.parse(textDescription) : ""
          }
          quoteBtn={tPerishable("header.quote-btn")}
          quoteProductID="btnQuoteGold"
          contactSales={tPerishable("header.contact-sales")}
          contactProductID="btnContactGold"
        />
        <div className="accordion-content-main">
          <div className="title">
            <h3>{tPerishable("header.prepare-charge")}</h3>
          </div>

          <div className="accordion-padd">
            <Accordion
              id={1}
              isOpen={openAccordion === 1}
              onToggle={setOpenAccordion}
              title={tPerishable("accordion-1.title")}
              content={
                accordion1
                  ? JSON.parse(accordion1) : "{}"
              }
            />

            <Accordion
              id={2}
              isOpen={openAccordion === 2}
              onToggle={setOpenAccordion}
              title={tPerishable("accordion-2.title")}
              content={
                accordion2
                  ? JSON.parse(accordion2) : "{}"
              }
            />

            <Accordion
              id={3}
              isOpen={openAccordion === 3}
              onToggle={setOpenAccordion}
              title={tPerishable("accordion-3.title")}
              content={
                tPerishable("accordion-3.content")
                  ? JSON.parse(tPerishable("accordion-3.content")) : "{}"
              }
            />
          </div>
          
        </div>
      </div>

      {/* ===================================================== */}

      <div className="more-info-content">
        <div className="more-info-box">
          <h5>{tPerishable("non-applicable-charges.title")}</h5>

          <div className="icons">
            <div className="item">
              <div className="icon"><img src={perishable1Icon} /></div>
              <p>{tPerishable("non-applicable-charges.item1")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={perishable2Icon} /></div>
              <p>{tPerishable("non-applicable-charges.item2")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={perishable3Icon} /></div>
              <p>{tPerishable("non-applicable-charges.item3")}</p>
            </div>
          </div>
        </div>

        <div className="more-info-box">
          <h5>{tPerishable("additional-conditions.title")}</h5>

          <div className="icons">
            <div className="item">
              <div className="icon"><img src={perishable4Icon} /></div>
              <p>{tPerishable("additional-conditions.item1")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={perishable5Icon} /></div>
              <p>{tPerishable("additional-conditions.item2")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={perishable6Icon} /></div>
              <p>{tPerishable("additional-conditions.item3")}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PerishableGoods;
